import { Link } from "react-router-dom";

export const Logo = ({ light = false }) => (
  <Link to="/" data-testid={light ? "footer-logo" : "nav-logo"} className="flex items-center gap-3" aria-label="KRIMZON home">
    <img src="/img/logo_icon.png" alt="" className="h-11 w-auto" />
    <img src="/img/logo_word.png" alt="KRIMZON" className={`h-[18px] w-auto ${light ? "brightness-0 invert" : ""}`} />
  </Link>
);
